import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = ({ showSlidebar = false }) => {
  const [activeSection, setActiveSection] = useState('');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = (section) => {
    setActiveSection(section);
  };

  const handleMouseLeave = () => {
    setActiveSection('');
    // Forcer un reset immédiat de la position
    setTimeout(() => {
      setActiveSection('');
    }, 0);
  };

  const handleMouseMove = (e) => {
    const nav = e.currentTarget;
    const rect = nav.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setMousePosition({ x, y });
  };

  // Forcer le recalcul quand la slidebar devient visible
  useEffect(() => {
    if (showSlidebar && activeSection) {
      // Petit délai pour s'assurer que les éléments sont rendus
      setTimeout(() => {
        setActiveSection(activeSection);
      }, 10);
    }
  }, [showSlidebar, activeSection]);

  const getBaguetteStyle = () => {
    if (!activeSection) {
      return { 
        opacity: 0, 
        width: '0',
        left: '0',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
      };
    }
    
    // Utiliser les dimensions réelles des éléments DOM
    const navLinks = document.querySelectorAll('.nav-link');
    const navBrand = document.querySelector('.nav-brand');
    const nav = document.querySelector('.nav');
    
    if (!navLinks.length || !navBrand || !nav) {
      return { 
        opacity: 0, 
        width: '0',
        left: '0',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
      };
    }
    
    const navRect = nav.getBoundingClientRect();
    
    // Trouver le lien actif
    const activeLink = Array.from(navLinks).find(link => 
      link.textContent.trim() === activeSection.toUpperCase()
    );
    
    if (!activeLink) {
      return { 
        opacity: 0, 
        width: '0',
        left: '0',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
      };
    }
    
    const linkRect = activeLink.getBoundingClientRect();
    const relativeLeft = linkRect.left - navRect.left;
    const linkWidth = linkRect.width;
    
    // Vérifier que les valeurs sont valides
    if (isNaN(relativeLeft) || isNaN(linkWidth) || relativeLeft < 0 || linkWidth <= 0) {
      return { 
        opacity: 0, 
        width: '0',
        left: '0',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
      };
    }
    
    // Si c'est le dernier élément (CONTACT), étendre jusqu'au bout
    const isLastElement = activeSection === 'contact';
    const finalWidth = isLastElement ? 
      (navRect.width - relativeLeft + 5) : // +5px pour dépasser légèrement
      linkWidth;
    
    return {
      opacity: 1,
      left: `${relativeLeft}px`,
      width: `${finalWidth}px`,
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    };
  };

  return (
    <header className={`header ${showSlidebar ? 'show' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <nav 
        className="nav"
        onMouseLeave={handleMouseLeave}
      >
        <div className="nav-brand">
          <a
            href="#"
            className="nav-logo"
            onClick={(e) => {
              e.preventDefault();
              setIsMenuOpen((open) => !open);
            }}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
          >
            <img src="/assets/icons/logo-otr-spiral.png" alt="O.T.R. STUDIO" />
          </a>
        </div>
        <button 
          className="hamburger-menu"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
          aria-expanded={isMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        <ul className={`nav-menu ${isMenuOpen ? 'show' : ''}`}>
          <li className="nav-item">
            <a 
              href="#production" 
              className="nav-link"
              onMouseEnter={() => handleMouseEnter('production')}
              onMouseLeave={handleMouseLeave}
              onClick={() => setIsMenuOpen(false)}
            >
              PRODUCTION
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#services" 
              className="nav-link"
              onMouseEnter={() => handleMouseEnter('services')}
              onMouseLeave={handleMouseLeave}
              onClick={() => setIsMenuOpen(false)}
            >
              SERVICES
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#contact" 
              className="nav-link"
              onMouseEnter={() => handleMouseEnter('contact')}
              onMouseLeave={handleMouseLeave}
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT
            </a>
          </li>
        </ul>
        <div 
          className="nav-baguette"
          style={getBaguetteStyle()}
        ></div>
      </nav>
    </header>
  );
};

export default Header;

